export default __webpack_public_path__ + "static/media/japantrad7.5d7ed577.png";